<rt-icon
  name="assignment-turned-in"
  [rtTooltip]="'app.requisitions.details_page.requisition_only_tooltip' | translate"
/>
